import { writable, get as getStore } from "svelte/store";
import app from "@/store/app.js";
import { toasts } from "svelte-toasts";
import { onDestroy } from 'svelte';

export function clickOutside(element, callbackFunction) {
    function onClick(event) {
        if (!element.contains(event.target)) {
            callbackFunction();
        }
    }
    document.body.addEventListener("click", onClick);
    return {
        update(newCallbackFunction) {
            callbackFunction = newCallbackFunction;
        },
        destroy() {
            document.body.removeEventListener("click", onClick);
        },
    };
}

export function copy(data) {
    return JSON.parse(JSON.stringify(data))
}

export function set(name, type) {
    const value = writable(localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : type);
    value.subscribe(val => { localStorage.setItem(name, JSON.stringify(val)) });
    return value;
}

export function persist(name, data) {
    let local = localStorage.getItem(name);
    const value = writable(local ? JSON.parse(local) : data);

    if (!local) value.set(copy(data));

    value.subscribe(val => {
        localStorage.setItem(name, JSON.stringify(val));
    });

    value.reset = () => value.set(copy(data));

    value.val = (key) => getStore(value)[key];

    value.all = () => getStore(value);

    value.commit = (key, val) => {
        let temp = getStore(value);
        temp[key] = val != null ? val : data[key];
        value.set(temp);
        return temp;
    };

    value.clear = (key) => {
        let temp = getStore(value);
        temp[key] = data[key];
        value.set(temp);
        return temp;
    };

    for (let x of Object.keys(data)) {
        if (!Object.keys(JSON.parse(local) || {}).includes(x)) {
            let temp = getStore(value);
            temp[x] = data[x];
            value.set(temp);
        }
    }

    value.watch = (keys, callback) => {
        const isArray = Array.isArray(keys)
        let previous = isArray ? keys.map(k => getStore(value)[k]) : getStore(value)[keys]

        const unsub = value.subscribe(current => {
            const currentValues = isArray ? keys.map(k => current[k]) : current[keys]
            const changed = isArray ? currentValues.some((v, i) => v !== previous[i]) : currentValues !== previous

            if (changed) {
                if (isArray) {
                    previous = currentValues
                    callback(currentValues)
                } else {
                    const oldVal = previous
                    const newVal = currentValues
                    previous = newVal
                    callback(oldVal, newVal)
                }
            }
        })

        onDestroy(unsub)
        return unsub
    }

    return value;
}

export function wait(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function push(path) {
    app.commit('url', path)
}

export function pop() {
    window.history.back()
}

export const successToast = async (msg, time = 5000) => {
    toasts.add({
        title: msg,
        description: "",
        duration: time,
        type: "success",
    });
};

export const errorToast = async (msg) => {
    toasts.add({
        title: msg,
        description: "",
        duration: 5000,
        type: "error",
    });
};

export const validateEmail = function (email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

export const searchList = function (list, term) {
    if (!term) return list;
    return list.filter((el) => Object.values(el).filter(util).length > 0);

    function util(item) {
        let result = JSON.stringify(item || "");
        result = result.toLowerCase().replaceAll('"', "");
        return result.search(term.toLowerCase()) >= 0;
    }
}